export default __webpack_public_path__ + "static/media/acms-wiki.9ebfef08.svg";